var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Auth } from "aws-amplify";
export var CHALLENGE_TOKEN = "SOFTWARE_TOKEN_MFA";
export var CHALLENGE_SMS = "'SMS_MFA'";
export var CHALLENGE_NEW_PASSWORD = "NEW_PASSWORD_REQUIRED";
export var CHALLENGE_SETUP = "MFA_SETUP";
var URL_PASSWORD_RESET = process.env.REACT_APP_URL_PASSWORD_RESET;
export function withIdTokenInAuthenticationHeader(headers) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Auth.currentSession()
                    .then(function (session) { return session.getIdToken().getJwtToken(); })
                    .then(function (token) { return Object.assign({}, headers, { "Authorization": "Bearer " + token }); })];
        });
    });
}
export function withAccessTokenInAuthenticationHeader(headers) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Auth.currentSession()
                    .then(function (session) { return session.getAccessToken().getJwtToken(); })
                    .then(function (token) { return Object.assign({}, headers, { "Authorization": "Bearer " + token }); })];
        });
    });
}
export function requestPasswordReset(email) {
    return __awaiter(this, void 0, void 0, function () {
        var request;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        email: email,
                        originURL: window.location.hostname
                    };
                    return [4 /*yield*/, fetch(URL_PASSWORD_RESET, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(request)
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function isValidEmailAddress(email) {
    if (email === "")
        return false;
    var regex = RegExp("^[-!#$%&'*+/0-9=?A-Z^_a-z{|}~](\\.?[-!#$%&'*+/0-9=?A-Z^_a-z{|}~])*" +
        "@[a-zA-Z](-?[a-zA-Z0-9])*(\\.[a-zA-Z](-?[a-zA-Z0-9])*)+$");
    return regex.test(email);
}
export function isValidPassword(password) {
    if (password.length < 8)
        return false;
    var lowercaseLetters = RegExp("[a-z]");
    var uppercaseLetters = RegExp("[A-Z]");
    var numbers = RegExp("[0-9]");
    var specialSigns = RegExp("[\\^$*.\\[\\]{}()?\"!@#%&/\\\\,><':;|_~`]");
    return lowercaseLetters.test(password)
        && uppercaseLetters.test(password)
        && numbers.test(password)
        && specialSigns.test(password);
}
export function isValidMattermostUsername(name) {
    if (name === "")
        return true;
    var USER_NAME_MAX_LENGTH = 22;
    var USER_NAME_MIN_LENGTH = 3;
    var validUsernameChars = new RegExp("^[a-z0-9.\\-_]+$");
    return name.length >= USER_NAME_MIN_LENGTH && name.length <= USER_NAME_MAX_LENGTH && validUsernameChars.test(name);
}
export function isReservedMattermostUserName(mattermostUsername) {
    var reservedNames = process.env.REACT_APP_RESERVED_MATTERMOST_USERNAMES.split(",");
    for (var _i = 0, reservedNames_1 = reservedNames; _i < reservedNames_1.length; _i++) {
        var name_1 = reservedNames_1[_i];
        if (mattermostUsername.trim() === name_1.trim())
            return true;
    }
    return false;
}
//# sourceMappingURL=auth_util.js.map